/*
 * @Author: cryi.liu
 * @Date: 2020-04-29 17:38:52
 * @LastEditTime: 2020-06-16 15:42:59
 * @Description: 考试中心路由配置
 */

const prefix = '';

export default [
  {
    path: `${prefix}/question/library`,
    name: 'ExamQuestionLibrary',
    component: () => import(/* webpackChunkName: "examQuestionLibrary" */'../../views/exam/question/library/Index.vue'),
    meta: {
      page: '试题库',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/question/detail/:libraryId`,
    name: 'ExamQuestionDetail',
    component: () => import(/* webpackChunkName: "examQuestionDetail" */'../../views/exam/question/detail/Index.vue'),
    props: true,
    meta: {
      page: '题目详情',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/paper/create/:examId`,
    name: 'CreateTestPaper',
    component: () => import(/* webpackChunkName: "examCreatePaper" */'../../views/exam/paper/create/Index.vue'),
    props: true,
    meta: {
      page: '新建试卷',
      layout: 'pss',
      type: 'create',
    },
  },
  {
    path: `${prefix}/paper/edit/:paperIdForRoute`,
    name: 'EditTestPaper',
    component: () => import(/* webpackChunkName: "examEditPaper" */'../../views/exam/paper/create/Index.vue'),
    props: true,
    meta: {
      page: '修改试卷',
      layout: 'pss',
      type: 'edit',
    },
  },
  {
    path: `${prefix}/paper/preview/:examId`,
    name: 'TestPaperPreview',
    component: () => import(/* webpackChunkName: "examPaperInfoPreview" */'../../views/exam/paper/preview/Index.vue'),
    props: true,
    meta: {
      type: 'preview',
      page: '试卷信息预览',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/paper/approval/:examId/:approveId`,
    name: 'TestPaperApproval',
    component: () => import(/* webpackChunkName: "examPaperInfoPreview" */'../../views/exam/paper/preview/Index.vue'),
    props: true,
    meta: {
      type: 'approval',
      page: '统考审批详情',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/paper/detail/:paperId`,
    name: 'ExamPaperDetail',
    component: () => import(/* webpackChunkName: "examPaperDetail" */'../../views/exam/paper/detail/Index.vue'),
    props: true,
    meta: {
      page: '试卷详情',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/answer/online/:examId`,
    name: 'ExamAnswerOnline',
    component: () => import(/* webpackChunkName: "examAnswerOnline" */'../../views/exam/answer/online/Index.vue'),
    props: true,
    meta: {
      page: '考生答题',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/answer/detail`,
    name: 'ExamAnswerDetail',
    component: () => import(/* webpackChunkName: "examAnswerDetail" */'../../views/exam/answer/detail/Index.vue'),
    meta: {
      page: '考生答题详情',
      layout: 'pss',
    },
  },
  {
    path: `${prefix}/answer/mark/:examId`,
    name: 'ExamAnswerMark',
    component: () => import(/* webpackChunkName: "examAnswerMark" */'../../views/exam/answer/mark/Index.vue'),
    props: true,
    meta: {
      page: '答题阅卷',
      layout: 'pss',
    },
  },
];
